export default function downloadCsv(fileName: string, csvData: string) {
  // This is a workaround to allow a user to download this csv data, or if that doesn't work,
  // then at least open it in a new tab for them to view and copy to the clipboard.
  // 1. Create a new blob url.
  // 2a. Redirect the user to it in a new tab.
  // 2b. Except on IE where we use a .msSaveBlob() function
  const dataBlob = new Blob([csvData], { type: 'text/csv' });
  const dataURL = URL.createObjectURL(dataBlob);

  if (navigator && navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(dataBlob, fileName);
  } else {
    const tempLink = document.createElement('a');
    document.body.appendChild(tempLink);
    tempLink.href = dataURL;
    tempLink.setAttribute('download', fileName);
    // If running this function in cypress, then don't actually download the file - just leave the
    // a tag in the dom so that cypress can inspect it.
    // Read more: https://github.com/cypress-io/cypress/issues/949#issuecomment-400252677
    if ((window as any).Cypress) {
      return;
    }
    tempLink.click();
    document.body.removeChild(tempLink);
  }
}
